import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 43.86" {...this.props}><title>location-active</title><path fill="currentColor" stroke="#fff" strokeMiterlimit="10" strokeWidth="2" d="M1 29.5v-22L7.5 1H29v28.5l-14 13-14-13z" /><path fill="#fff" d="M14.02 24.25l-5.05-4.81 1.73-1.81 3.28 3.12 6.87-6.86 1.77 1.77-8.6 8.59" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/icons/location-active.inline.svg